<template>
    <div>
        <div class="head-container">
            <Row>
                <Col span="8">
                    <div class="form-label">
                        <span>车牌号：</span>
                    </div>
                    <div class="form-input">
                        <Input v-model="formParam.carPlateNumber" @on-keyup="onPlateKeyUp"/>
                    </div>
                </Col>
                <Col span="8">
                    <div class="form-label">
                        <span>工单状态：</span>
                    </div>
                    <div class="form-input">
                        <Select v-model="formParam.status" filterable clearable>
                            <Option v-for="item in statusList" :value="item.id + ''" :key="item.id">{{ item.name }}</Option>
                        </Select>
                    </div>
                </Col>
                <Col span="8">
                    <div class="form-label">
                        <span>客户名称：</span>
                    </div>
                    <div class="form-input">
                        <Input v-model="formParam.memberName"/>
                    </div>
                </Col>
            </Row>
            <Row style="margin-top: 15px">
                <Col span="18">
                    <div class="form-label">
                        <span>收车日期：</span>
                    </div>
                    <div style="display: inline-block">
                        <RadioGroup v-model="quickDate" type="button" @on-change="dateRadioChange">
                            <Radio label="三个月内"></Radio>
                            <Radio label="一个月内"></Radio>
                            <Radio label="15天内"></Radio>
                            <Radio label="7天内"></Radio>
                            <Radio label="3天内"></Radio>
                            <Radio label="当天"></Radio>
                            <Radio label="hide" style="display: none"></Radio>
                        </RadioGroup>
                    </div>
                    <div style="display: inline-block; width: auto;margin-left: 20px">
                        <span>自定义：</span>
                    </div>
                    <div style="display: inline-block">
                        <DatePicker v-model="dateRange" format="yyyy-MM-dd" @on-change="dateChange"
                                    type="daterange" placement="bottom-end"
                                    placeholder="选择接车日期"/>
                    </div>
                </Col>
                <Col span="6">
                    <div style="text-align: right">
                        <Button type="primary" icon="md-search" style="margin-right: 10px" @click="onQuery">查询</Button>
                        <Button icon="md-refresh" @click="reset">重置</Button>
                    </div>
                </Col>
            </Row>
        </div>
        <div class="under-container">
            <div v-for="(item, index) in workOrderList" :key="index" class="car-item" @click="toRepairInfo(item)">
                <Row style="padding: 5px 0 0 5px;color:#044aa1">
                    <Col :span="18">
                        <div class="order-number">
                            {{ item.orderNumber }}
                        </div>
                    </Col>
                    <Col :span="6">
                        <div class="car-status">
                            {{ getStatusName(item.status) }}
                        </div>
                    </Col>
                </Row>
                <div style="text-align: center">
                    <div class="car-number">
                        {{ item.carPlateNumber }}
                    </div>
                    <div style="color: #2d8cf0">
                        {{ item.memberName }}
                    </div>
                    <div style="font-size: 12px">
                        {{ item.classifyName }}
                    </div>
                </div>
                <div class="order-user">
                    {{ item.createUserName }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {queryUnderRepairCar} from "@/api/business"

export default {
    name: "UnderRepairCar",
    data() {
        return {
            formParam: {
                carPlateNumber: '',
                status: '',
                memberName: '',
                current: 1,
                size: 50,
                total: 0,
            },
            dateRange: [],
            statusList: [{
                id: '',
                name: '全部',
            }, {
                id: '0',
                name: '已接车',
            }, {
                id: '1',
                name: '维修中',
            }],
            workOrderList: [],
            quickDate: '一个月内',
        }
    },
    mounted() {
        let {start, end} = this.getDateRange(30)
        this.formParam.createTime = start
        this.formParam.updateTime = end
        this.onQuery()
    },
    methods: {
        onPlateKeyUp() {
            this.formParam.carPlateNumber = this.formParam.carPlateNumber.toUpperCase()
        },
        reset() {
            this.formParam.carPlateNumber = ''
            this.formParam.status = ''
            this.formParam.memberName = ''
            this.formParam.createTime = undefined
            this.formParam.updateTime = undefined
            this.dateRange = []
        },
        onQuery() {
            queryUnderRepairCar(this.formParam).then((res) => {
                this.workOrderList = res.data
                this.formParam.total = res.total
            })
        },
        dateChange(range) {
            if (range.length > 1) {
                if (range[0].length > 1 && range[1].length > 1) {
                    this.formParam.createTime = range[0] + " 00:00:00"
                    this.formParam.updateTime = range[1] + " 23:59:59"
                    this.onQuery()
                    this.quickDate = 'hide'
                } else {
                    this.formParam.createTime = undefined
                    this.formParam.updateTime = undefined
                }
            } else {
                this.formParam.createTime = undefined
                this.formParam.updateTime = undefined
            }
        },
        dateRadioChange(e) {
            this.formParam.createTime = undefined
            this.formParam.updateTime = undefined
            this.dateRange = []
            let day = 1
            switch (e) {
                case 'hide':
                    return
                case '当天':
                    day = 1
                    break
                case '3天内':
                    day = 3
                    break
                case '7天内':
                    day = 7
                    break
                case '15天内':
                    day = 15
                    break
                case '一个月内':
                    day = 30
                    break
                case '三个月内':
                    day = 90
                    break
                default:
                    day = 1
            }
            let {start, end} = this.getDateRange(day)
            this.formParam.createTime = start
            this.formParam.updateTime = end
            this.onQuery()
        },
        getDateRange(day) {
            const end = new Date()
            end.setHours(23, 59, 59, 999)

            const start = new Date()
            start.setDate(start.getDate() - (day - 1)) // 3天包括今天，所以减2
            start.setHours(0, 0, 0, 0)

            return {
                start: this.formatDate(start),
                end: this.formatDate(end),
            }
        },
        formatDate(date) {
            const year = date.getFullYear()
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const day = String(date.getDate()).padStart(2, '0')
            const hours = String(date.getHours()).padStart(2, '0')
            const minutes = String(date.getMinutes()).padStart(2, '0')
            const seconds = String(date.getSeconds()).padStart(2, '0')

            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
        },
        getStatusName(status) {
            switch (status) {
                case 0:
                    return '已接车'
                case 1:
                    return '维修中'
                case 2:
                    return '待付款'
                case 5:
                    return '已完成'
                default:
                    return '未知车辆'
            }
        },
        toRepairInfo(item) {
            this.$router.push({name: "repairInfo", query: {orderNumber: item.orderNumber}})
        },
    },
}
</script>

<style scoped>
.head-container {
    margin: 10px;
    background: #fafafa;
    padding: 10px;
}

.form-label {
    display: inline-block;
    font-weight: bold;
    text-align: right;
    width: 80px;
}

.form-input {
    display: inline-block;
    width: calc(100% - 80px);
}

.under-container {
    margin: 10px;
    background: #ffffff;
    padding: 10px;
    text-align: left;
}

.car-item {
    border-top: 4px solid #2d8cf0;
    border-left: 1px solid #d7d7d7;
    border-right: 1px solid #d7d7d7;
    border-bottom: 1px solid #d7d7d7;
    display: inline-block;
    width: 180px;
    height: 145px;
    background: #fafafa;
    cursor: pointer;
    position: relative;
    margin-left: 10px;
    margin-right: 10px;
    vertical-align: top;
}

.order-number {
    font-size: 12px;
    margin-top: 3px;
}

.car-status {
    background: #044aa1;
    border-radius: 5px;
    color: #fdfdfd;
    font-size: 10px;
    font-weight: bold;
    text-align: center;
    padding: 4px 0 2px 0;
    margin-right: 5px;
}

.car-number {
    display: inline-block;
    font-size: 20px;
    font-weight: bold;
    margin-top: 15px;
    color: #044aa1;
}

.order-user {
    font-size: 12px;
    color: #044aa1;
    text-align: right;
    position: absolute;
    right: 5px;
    bottom: 2px;
}
</style>
